export default "__VITE_ASSET__WQUo6WHU__"